import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUps = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 13,
	viewBox: "0 0 7 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 0H2.78571L0 7.11905H3.09524L0.928571 12.6905H1.85714L6.5 5.57143H4.02381L6.5 0Z",
		fill: "#1F3171"
	})
});
export default SvgUps;
